import { qportalApi } from './qportal-api';
const previewDiscard = (timeSheetId, signal) => qportalApi.get(`timeSheet/${encodeURIComponent(timeSheetId)}/discard-preview`, { signal });
const discardOpen = (timeSheetId, expectedVersion) => qportalApi.post(`timeSheet/${encodeURIComponent(timeSheetId)}/discard`, { expectedVersion });
const getWeeksByMonthYearAndAssignmentId = (request) => {
    return qportalApi.postForm(`timeSheet/getWeeklyTimeSheetsByMonthYearAndAssigmentId`, request);
};
const getTimeSheetsUsingStatus = (Status) => {
    return qportalApi.get(`timeSheet/GetTimeSheetsUsingStatus/${Status}`);
};
const uploadMonthlyTimeSheet = (document) => {
    // ContextType=0 is a valid ClientAssignment value. Build this multipart
    // request explicitly so it cannot be removed by truthiness filtering.
    const formData = new FormData();
    formData.append('Year', String(document.Year));
    formData.append('Month', String(document.Month));
    formData.append('TimeSheetDocument', document.TimeSheetDocument);
    if (document.ContextType !== undefined) {
        formData.append('ContextType', String(document.ContextType));
    }
    if (document.ContextId)
        formData.append('ContextId', document.ContextId);
    formData.append('AssignmentId', document.AssignmentId || '00000000-0000-0000-0000-000000000000');
    return qportalApi.postForm('timeSheet/uploadMonthlyTimeSheet', formData);
};
const getTimeSheetCountsByStatus = () => {
    return qportalApi.get('timeSheet/getTimeSheetCounts');
};
const downloadMyTimeSheetPdf = async (assignmentId, month, year) => {
    const response = await qportalApi.get('timeSheet/downloadMyTimeSheetPdf', {
        params: { assignmentId, month, year },
        responseType: 'blob'
    });
    return response.data;
};
const TimeSheetApi = {
    previewDiscard,
    discardOpen,
    getTimeSheetsUsingStatus,
    uploadMonthlyTimeSheet,
    getTimeSheetCountsByStatus,
    getWeeksByMonthYearAndAssignmentId,
    downloadMyTimeSheetPdf
};
export default TimeSheetApi;
